import React, { useMemo } from 'react';

import { NullableFormatter } from '~/@components/Formatters';
import { ActionVariant, ITableCellAction, TableCellActions } from '~/@components/Table/TableCellActions';
import { IDeliveryLine } from '~/@store/deliveryLines';

type Props = {
    deliveryLine: IDeliveryLine;
};

export const DeliveryLineTransportInvoiceCell = ({ deliveryLine }: Props) => {
    const actions: Array<ITableCellAction> = useMemo(
        () => [
            {
                variant: ActionVariant.COPY,
                content: deliveryLine.transportationInvoiceNumber,
            },
        ],
        [deliveryLine]
    );

    return (
        <TableCellActions actions={actions}>
            <NullableFormatter>{deliveryLine.transportationInvoiceNumber}</NullableFormatter>
        </TableCellActions>
    );
};
